import React, { useEffect, useContext } from "react";
import InteractiveRotaryGfx from "../cards/InteractiveRotaryGfx";
import CardHeader from "../cards/common/CardHeader";
import CardSubheader from "../cards/common/CardSubheader";
import { trackPageView } from "../../utils/adobeAnalytics";
import AppContext from "../AppContext";
import Data from "./sampleRotaryGFXData";
import { isValidJSON } from "../../utils/helper";
import { pushDatatoAdobeLayer } from '../../analytics/pmiAdobeLog';

const InteractionDemoPage = (isAuthenticated) => {

  // Adobe Analytics
  const { isFirstRender, setIsFirstRender } = useContext(AppContext);
  useEffect(() => {
    if (!isFirstRender) {
      trackPageView({ eVar4: "interaction demo page" });
    } else {
      setIsFirstRender(false);
    }

  }, []);
  useEffect(() => {
    pushDatatoAdobeLayer({ status: isAuthenticated })
  }, [isAuthenticated]);
  // end Adobe Analytics

  let jsonText = JSON.stringify(Data);

  const data = isValidJSON(jsonText) ? JSON.parse(jsonText) : [];

  const post = {
    contentType: "CTRotaryGraphic",
    contentKey: "test",
    source: "Test Source",
  };

  const title = "Integration Interaction";
  const width = 400; // Changing the width will break the graphic. Width must be the same as #rotaryGFXContainer in "index.css"

  return (
    <div className="container mx-auto px-4 pt-10 md:pt-24">
      <div className="flex -mx-5 justify-center">
        <div
          className="w-full lg:flex-1 px-5 lg:px-8"
          style={{ maxWidth: "730px" }}
        >
          <div className="bg-white flex border border-gray-500 rounded-sm mb-5">
            <div className="w-full pb-20">
              <CardHeader
                post={post}
                showPmbokModal={false}
                canProceed={true}
              />

              <div className="px-5 mt-4">
                <div>
                  <CardSubheader subheader="Post Title" isExpandable={false} />
                </div>

                <InteractiveRotaryGfx
                  items={data.items}
                  relations={data.relations}
                  width={width}
                  title={title}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InteractionDemoPage;
